type NumberFormattingOptions = {
  style?: 'decimal' | 'percent';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const formatNumber = (value: number | string, options?: NumberFormattingOptions) => {
  const { style = 'decimal', minimumFractionDigits = 1, maximumFractionDigits } = options || {};

  const numericValue = Number(value);

  if (style === 'percent') {
    return (numericValue / 100).toLocaleString(undefined, {
      maximumFractionDigits,
      minimumFractionDigits,
      style,
    });
  }

  return numericValue.toLocaleString(undefined, {
    maximumFractionDigits,
    minimumFractionDigits,
    style,
  });
};
